<template>
  <div class="backUp" v-if="isShow" @click="backUp"></div>
</template>
<script>
export default {
  name: "back-up",
  data() {
    return {
      isShow: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.backUpIsShow);
  },
  destroyed() {
    window.removeEventListener("scroll", this.backUpIsShow);
  },
  methods: {
    backUp() {
      document.querySelector("html").scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    },
    backUpIsShow() {
      const viewport = document.querySelector("html");
      this.isShow = viewport.getBoundingClientRect().y < -200;
    }
  }
};
</script>
<style lang="scss" scoped>
.backUp {
  position: fixed;
  right: 5vw;
  bottom: 100px;
  width: 66px;
  height: 66px;
  background-image: url("~@/assets/case/btn_up.png");
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  z-index: 100;
}
</style>
